import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'code'
})
export class CodePipe implements PipeTransform {

  transform(name: string, instance: object, language: string): any {
    return instance[language + name + 'Prism'];
  }

}
